export const diagnosticGraphFlag = 'diagnosticGraph';
export const summaryCardFlag = 'summaryCard';
export const metricPanelFlag = 'metricPanel';
